// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"f63eee4e","455":"5fe85502","977":"e15f659f"}[chunkId] + ".chunk.js";
};